module.exports = __webpack_public_path__ + "static/irdeto-05b695b4575ddf772975656c9c1f5ed4.png";